import React from 'react'
import 'antd/dist/antd.css';
import { SearchOutlined, EnvironmentOutlined, CheckOutlined, HomeOutlined } from '@ant-design/icons';
import { PAGE_COMPANY, PAGE_NAME } from '../../config'
import Top from '../../components/common/Top'
import Footer from '../../components/common/Footer'
import TenantDirectModal from '../../components/model/TenantDirectModal'
import { userInfoFunc } from '../../config/func'
import { Layout, Input, Button, Row, Col, Typography, Spin, message, Tooltip, Modal, Select } from 'antd';
import {
    getWebsiteProject,
    getTransactionList,
    ListTransactionPublicityPaging,
    getApplyTransactionCheck,
    getSupplyProject,
    getFilesList,
    getApplyingTransaction,
    applyQueue,
    projectWebDetailInfo,
    applyReserveRegister,
    canReserveRegister
} from '../../utils/api'
import QualificationPublic from '../../components/model/qualificationPublic'
import QualificationSupply from '../../components/model/qualificationSupply'
import QueryProgress from '../../components/model/queryProgress'
import {
    MARRY_STATUS_OPTIONS,
    isMarryOptionDisabledForApplyType,
    isApplyTypeOptionDisabledForMarry,
    getApplyTypeMarryConflictMessage,
} from '../../utils/applyTypeMarryRule'
import actionWays from "../../redux/actions";
import { connect } from "react-redux";
import moment from 'moment'
import { withRouter } from "react-router-dom";
import '../../inphone.scss'
import applyIcon from '../../assets/images/apply.png'
import guideIcon from '../../assets/images/guide.png'
import downloadIcon from '../../assets/images/download.png'
import faqIcon from '../../assets/images/faq.png'
import tenantDirectIcon from '../../assets/images/tenant-direct-icon.png'
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "swiper/swiper.scss";
import {
    Navigation,
    Pagination,
    Scrollbar,
    A11y,
    Autoplay,
} from "swiper/swiper.esm.js";
import HomeFixedBtn from '../../components/common/HomeFixedBtn'
import SelfTest from '../../components/common/selfTest';

const { Content } = Layout;
const { Title } = Typography;
const { Option } = Select;

const workGuideList = [
    {
        title: '申请条件',
        desc: '快速查询申请条件',
        icon: applyIcon,
        url: 'apply',
    },
    {
        title: '租赁指南',
        desc: '快速查询租赁指南',
        icon: guideIcon,
        url: 'guide',
    },
    {
        title: '资料下载',
        desc: '快速查找相关下载',
        icon: downloadIcon,
        url: 'download',
    },
    {
        title: '常见问题',
        desc: '快速查询常见问题',
        icon: faqIcon,
        url: 'faq',
    },
]

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 'home',
            publicList: [],
            projectList: [],
            showHome: false,
            showOther: false,
            projectName: '',
            windowWidth: '',
            Views: false,
            secondsToGo: 5,
            okText: '5秒',
            policyList: [],
            backgroundList: [],
            reserveModalVisible: false,
            reserveApplyType: '',
            reservePaiduiHouseType: '',
            reserveMarry: '',
            reserveWorkUnitName: '',
            reserveWebsiteProjects: [],
            reserveSelectedProjectNo: undefined,
            reserveSelectedProjectName: '',
            reserveProjectDetail: null,
            reserveIdnoJiaoyan: null,
            reserveDetailLoading: false,
            tenantDirectVisible: false,
        };
        this.industryNews = null
        this.industryOther = null
        this.selfTestRef = null
        this.openLoginHandler = null
    }

    componentDidMount() {
        if (!sessionStorage.getItem('addInform')) {
            this.ViewShow()
        }
        this.onloading()
        if (this.props.history.location) {
            if (this.props.history.location.query) {
                if (this.props.history.location.query.type == 'getQueryProgressList') {
                    this.getQueryProgressList()
                }
                if (this.props.history.location.query.type == 'getQualificationList') {
                    this.getQualificationList()
                }
            }
        }
    }
    componentWillUnmount() {
        const { showHome, showOther } = this.state
        if (showHome) {
            clearInterval(this.industryNews);
        }
        if (showOther) {
            clearInterval(this.industryOther);
        }
    }
    onloading = async () => {
        let opts = {
            pageIndex: 0,
            pageSize: 100,
        }
        let opt = {
            projectName: '',
            district: '宝山区',
            layout: '',
            minRent: '',
            maxRent: '',
            status: '',
            pageIndex: 0,
            pageSize: 6,
            choiceness: '1',
        }
        // 获取公示名单
        let publicList = await ListTransactionPublicityPaging(opts)

        // 获取项目列表
        let projectList = await getWebsiteProject(opt)
        // 获取项目供应情况
        let supplyList = await getSupplyProject(opts)
        if (publicList?.code === 0 && projectList?.code === 0) {
            for (let i in projectList.data.pageContent) {
                projectList.data.pageContent[i].mediaUrl = projectList.data.pageContent[i].mediaUrl ? projectList.data.pageContent[i]?.mediaUrl.split(',') : ['']
                projectList.data.pageContent[i].thumbnail = projectList.data.pageContent[i].thumbnail ? projectList.data.pageContent[i]?.thumbnail.split(',') : ['']
            }
            this.setState({
                publicList: publicList.data.pageContent,
                projectList: projectList.data.pageContent,
                supplyList: supplyList.data.pageContent,
            })
            localStorage.setItem("messageNum", projectList?.message);
            // 滚动
            if (document.getElementById('homeId') !== null) {
                await this.taskIndustryNews();
                this.industryNews = setInterval(this.taskIndustryNews, 300);
                await this.taskIndustryOther();
                this.industryOther = setInterval(this.taskIndustryOther, 300);
                this.setState({
                    showHome: true,
                    showOther: true,
                })
            }
        } else {
            message.error(projectList?.message)
        }

        this.getPolicyList()
        this.getBannerList()
    }
    getPolicyList = async () => {
        const params = {
            type: 1,
            pageIndex: 0,
            pageSize: 3,
        };
        const res = await getFilesList(params);
        if (res.code === 0) {
            this.setState({
                policyList: res.data.pageContent,
            });
        }
    }
    getBannerList = async () => {
        const params = {
            type: 6,
            pageIndex: 0,
            pageSize: 999,
        };
        const res = await getFilesList(params);
        if (res.code === 0) {
            this.setState({
                backgroundList: res.data.pageContent?.sort((a, b) => a.sort - b.sort),
            });
        }
    }

    taskIndustryNews = () => {
        if (this.state.showHome) {
            if (this.refs.newDiv.scrollTop >= this.refs.newDivUI.offsetHeight - this.refs.newDiv.offsetHeight) {
                this.refs.newDiv.scrollTop = 0;
            }
            else {
                if (document.documentElement.clientWidth > 1903) {
                    this.refs.newDiv.scrollTop += 2;
                } else {
                    this.refs.newDiv.scrollTop += 1;
                }
            }

        }
    }
    taskIndustryOther = () => {
        if (this.state.showOther) {
            if (this.refs.newOther.scrollTop >= this.refs.newOtherUI.offsetHeight - this.refs.newOther.offsetHeight) {
                this.refs.newOther.scrollTop = 0;
            }
            else {
                if (document.documentElement.clientWidth > 1903) {
                    this.refs.newOther.scrollTop += 2;
                } else {
                    this.refs.newOther.scrollTop += 1;
                }
            }

        }
    }
    // 鼠标移入，挺住滚动
    handleIndustryNewsEnter = () => {
        clearInterval(this.industryNews);
    }
    // 鼠标移入，挺住滚动
    handleIndustryOtherEnter = () => {
        clearInterval(this.industryOther);
    }
    // 鼠标移出，开始滚动
    handleIndustryNewsLeave = () => {
        this.industryNews = setInterval(this.taskIndustryNews, 300);
    }
    // 鼠标移出，开始滚动
    handleIndustryOtherLeave = () => {
        this.industryOther = setInterval(this.taskIndustryOther, 300);
    }
    getProjectDetail = (projectName, projectNo) => {
        this.setState({
            showHome: false,
            showOther: false,
        }, () => {
            this.props.history.push({ pathname: '/belows', query: { projectName: projectName, projectNo: projectNo } })
        })
    }
    getProject = (projectName) => {
        this.setState({
            showHome: false,
            showOther: false,
        }, () => {
            this.props.history.push({ pathname: '/project', query: { projectName: projectName } })
        })
    }
    setValue = (n, e) => {
        const value = e.target ? e.target.value : e;
        let obj = {};
        obj[n] = value
        this.setState({
            ...obj
        });
    }
    // getProject = (projectName, projectNo) => {
    //     this.props.history.push({ pathname: '/belows', query: { projectName: projectName, projectNo: projectNo } })
    // }
    getApplyTransactionChecks = async (v) => {
        if (!v) {
            message.error('请先登录')
            return
        }
        let data = ''
        let list = await getApplyTransactionCheck({})
        if (list.code == 0) {
            data = '1'
            return data
        } else {
            data = '0'
            message.error(list.message)
            return data
        }
    }
    areatoraise = async () => {
        if (!this.props.userLoginInfo) {
            message.error('请先登录')
            return
        }
        let type = await this.getApplyTransactionChecks(this.props.userLoginInfo.id)
        if (type == '0') return
        this.props.history.push({ pathname: '/areatoraise', query: { type: undefined } })
    }
    cityListsl = () => {
        this.props.history.push({ pathname: '/citylist' })
    }

    fastWorkGuide = (v) => {
        console.log(v)
        this.props.history.push({ pathname: '/workGuide', query: { type: v.url } })
    }

    policyDetail = (v) => {
        this.props.history.push({ pathname: '/policy', query: { detail: v } })
    }

    htmlStr2text = (htmlStr) => {
        const node = new DOMParser().parseFromString(htmlStr, 'text/html')
        return node.body.innerText.replace(/\s+/g, '').substring(0, 70)
    }

    toSelfTest = () => {
        this.selfTestRef.openModal()
    }

    computeReserveIdnoJiaoyan = (value) => {
        let idnoG = null
        const values = value == undefined ? '' : value
        if (values.length == '18' || values.length === 18) {
            const myDate = new Date();
            const month = myDate.getMonth() + 1;
            const day = myDate.getDate();
            let age = myDate.getFullYear() - values.substring(6, 10) - 1;
            if (values.substring(10, 12) < month || values.substring(10, 12) == month && values.substring(12, 14) <= day) {
                age++;
            }
            if (parseInt(values.substr(16, 1)) % 2 == 1) {
                if (age >= 25) {
                    idnoG = true
                } else {
                    idnoG = false
                }
            } else {
                if (age >= 23) {
                    idnoG = true
                } else {
                    idnoG = false
                }
            }
        }
        this.setState({
            reserveIdnoJiaoyan: idnoG
        })
    }

    openReserveFromHome = async () => {
        if (!this.props.userLoginInfo?.id) {
            message.error('请先登录')
            return
        }
        let opt = {}
        let data = await canReserveRegister(opt)
        if (data.code == 0) {
            if (data.data.canReserve) {
                this.computeReserveIdnoJiaoyan(this.props.userLoginInfo?.idno)
                const opts = {
                    projectName: '',
                    district: '宝山区',
                    layout: '',
                    status: '',
                    houseType: '',
                    minRent: '',
                    maxRent: '',
                    pageIndex: 0,
                    pageSize: 500
                }
                const projectRes = await getWebsiteProject(opts)
                if (projectRes.code !== 0) {
                    message.error(projectRes.message)
                    return
                }
                const list = projectRes.data.pageContent || []
                this.setState({
                    reserveModalVisible: true,
                    reserveApplyType: '',
                    reservePaiduiHouseType: '',
                    reserveMarry: '',
                    reserveWorkUnitName: '',
                    reserveSelectedProjectNo: undefined,
                    reserveSelectedProjectName: '',
                    reserveProjectDetail: null,
                    reserveWebsiteProjects: list,
                    reserveDetailLoading: false,
                })
            } else {
                message.error(data.data.message);
            }
        } else {
            message.error(data.message);
        }
        // const data = await getApplyingTransaction({ userId: this.props.userLoginInfo.id })
        // if (data.code != 0) {
        //     message.error(data.message)
        //     return
        // }
    }

    onReserveProjectChange = async (projectNo) => {
        if (!projectNo) {
            this.setState({
                reserveSelectedProjectNo: undefined,
                reserveSelectedProjectName: '',
                reserveProjectDetail: null,
                reservePaiduiHouseType: '',
            })
            return
        }
        const item = this.state.reserveWebsiteProjects.find((p) => p.projectNo === projectNo)
        if (!item) return
        this.setState({
            reserveSelectedProjectNo: projectNo,
            reserveSelectedProjectName: item.projectName,
            reservePaiduiHouseType: '',
            reserveDetailLoading: true,
        })
        const detailRes = await projectWebDetailInfo({ projectNo })
        if (detailRes.code == 0) {
            let projectdata = detailRes.data
            if (projectdata.mediaUrl) {
                projectdata.mediaUrl = projectdata.mediaUrl.split(',')
            }
            this.setState({
                reserveProjectDetail: projectdata,
                reserveDetailLoading: false
            })
        } else {
            message.error(detailRes.message)
            this.setState({
                reserveProjectDetail: null,
                reserveDetailLoading: false
            })
        }
    }

    reserveHomeHouseTypeChange = (key) => {
        this.setState({
            reservePaiduiHouseType: key
        })
    }

    onReserveApplyTypeChange = (v) => {
        const updates = { reserveApplyType: v, reservePaiduiHouseType: '' }
        if (v === '单身人士' && this.state.reserveMarry === '已婚') {
            updates.reserveMarry = ''
        }
        this.setState(updates)
    }

    onReserveMarryChange = (v) => {
        const updates = { reserveMarry: v }
        if (v === '已婚' && this.state.reserveApplyType === '单身人士') {
            updates.reserveApplyType = ''
            updates.reservePaiduiHouseType = ''
        }
        this.setState(updates)
    }

    homeReserveLineup = async (projectName, houseType, maritalStatus, workUnit, applyType) => {
        let obj = { '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '十': 10 }
        let china = houseType.slice(0, 1)
        let opt = {}
        opt.projectName = projectName
        opt.houseType = obj[china]
        opt.maritalStatus = maritalStatus
        opt.workUnit = workUnit
        opt.applyType = applyType
        let data = await applyReserveRegister(opt)
        if (data.code == 0) {
            message.success('登记成功')
            this.setState({
                reserveModalVisible: false,
                reserveApplyType: '',
                reservePaiduiHouseType: '',
                reserveMarry: '',
                reserveWorkUnitName: '',
                reserveSelectedProjectNo: undefined,
                reserveSelectedProjectName: '',
                reserveProjectDetail: null,
                reserveWebsiteProjects: [],
            })
        } else {
            message.error(data.message);
        }
    }

    homeReserveOnLineup = async () => {
        let opt = {}
        opt.userId = this.props.userLoginInfo.id
        let data = await getApplyingTransaction(opt)
        if (data.code == 0) {
            if (data.data) {
                if (data.data.progress == '成功') {
                    this.homeReserveLineup(this.state.reservePaiduiHouseType, data.data.transactionNo)
                } else {
                    message.error('准入资格证正在审核中，请等待');
                }
            } else {
                message.error('请先去申请准入资格证');
            }
        } else {
            message.error(data.message);
        }
    }

    homeReserveHandleOk = () => {
        const { reserveSelectedProjectNo, reserveProjectDetail, reservePaiduiHouseType, reserveMarry, reserveApplyType, reserveWorkUnitName, reserveDetailLoading, reserveSelectedProjectName } = this.state
        if (reserveDetailLoading) {
            message.error('项目信息加载中，请稍候')
            return
        }
        if (!reserveSelectedProjectNo || !reserveProjectDetail) {
            message.error('请选择项目')
            return
        }
        if (!reserveApplyType) {
            message.error('请选择申请类型')
            return
        }
        if (!reserveMarry) {
            message.error('请选择婚姻状况')
            return
        }
        const applyMarryConflict = getApplyTypeMarryConflictMessage(reserveApplyType, reserveMarry)
        if (applyMarryConflict) {
            message.error(applyMarryConflict)
            return
        }
        if (!reservePaiduiHouseType) {
            message.error('请选择户型')
            return
        }
        if (reserveApplyType === '单身人士' && reservePaiduiHouseType !== '一' && reservePaiduiHouseType !== '二') {
            message.error('单身人士仅可选择一室户或二室户')
            return
        }
        if (!(reserveWorkUnitName || '').trim()) {
            message.error('请输入工作单位名称')
            return
        }
        // this.homeReserveOnLineup()
        this.homeReserveLineup(reserveSelectedProjectName, reservePaiduiHouseType, reserveMarry, reserveWorkUnitName, reserveApplyType)
    }

    homeReserveHandleCancel = () => {
        this.setState({
            reserveModalVisible: false,
            reserveApplyType: '',
            reservePaiduiHouseType: '',
            reserveMarry: '',
            reserveWorkUnitName: '',
            reserveSelectedProjectNo: undefined,
            reserveSelectedProjectName: '',
            reserveProjectDetail: null,
            reserveWebsiteProjects: [],
        })
    }

    render() {
        const { publicList, projectList, projectName, Views, secondsToGo, okText, supplyList, backgroundList, policyList, reserveModalVisible, reserveApplyType, reservePaiduiHouseType, reserveMarry, reserveWorkUnitName, reserveWebsiteProjects, reserveSelectedProjectNo, reserveProjectDetail, reserveDetailLoading, tenantDirectVisible } = this.state
        const size = 368 / 150
        return (
            <Layout style={{ minHeight: '100%', minWidth: '100%' }} id='homeId'>
                <Top
                    getQualificationList={this.getQualificationList}
                    getQueryProgressList={this.getQueryProgressList}
                    onRegisterOpenLogin={this.registerOpenLogin}
                />
                <TenantDirectModal
                    visible={tenantDirectVisible}
                    loggedIn={!!(this.props.userLoginInfo?.id || userInfoFunc(this.props.userLoginInfo))}
                    userInfo={this.props.userLoginInfo}
                    onClose={this.closeTenantDirectModal}
                    onLogin={this.openLoginFromTenantDirect}
                    onMyDirect={this.goToMyTenantDirect}
                />
                {/* <HomeFixedBtn toSelfTest={this.toSelfTest} history={this.props.history} /> */}
                <Layout>
                    <div className="homeTop">
                        <Swiper
                            className='homeSwiper'
                            spaceBetween={50}
                            slidesPerView={1}
                            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                            autoplay={{
                                delay: 10000,
                                disableOnInteraction: false,
                            }}
                        >
                            {
                                backgroundList.map((item, index) => {
                                    return (
                                        <SwiperSlide style={{ width: "100%", }} key={index}  >
                                            <img style={{ width: '100%', height: '100%' }} src={item.content} alt='暂无图片'></img>
                                        </SwiperSlide>
                                    );
                                })
                            }
                        </Swiper>
                        <div className="top-content" style={{ zIndex: 2, position: 'relative' }}>
                            <div>
                                <div className="col-lg-2"></div>
                                <div className="col-lg-8">
                                    {/* <div className="content">
                                        <Title level={1} style={{ marginBottom: '0' }}>安居如意在宝山</Title>
                                        <Title level={2}  >{PAGE_COMPANY}</Title>
                                    </div> */}
                                </div>
                                <div className="col-lg-2"></div>
                            </div>
                            <div className="bottom-nav">
                                <div className="col-lg-2"></div>
                                <div className="col-lg-8">
                                    <div>
                                        <div className="form">
                                            <div className="input">
                                                <Input placeholder="查找您的意向小区" onChange={this.setValue.bind(this, 'projectName')} />
                                            </div>
                                            <div style={{ position: 'relative' }}>
                                                <Button onClick={() => { this.cityListsl() }} className='ditu'>
                                                    <EnvironmentOutlined /><span><b style={{ fontWeight: 'normal' }}>地图找房</b> </span>
                                                </Button>
                                                <Button className='search-house' onClick={() => { this.getProject(projectName) }}><SearchOutlined />开始找房</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2"></div>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <div className="col-lg-2"></div>
                        <div className="col-lg-8">
                            {/* <Row className="qualification" align="middle">
                                <Col xl={8} lg={9} md={10} sm={14} onClick={() => { this.toSelfTest() }}>
                                    <div className="qualification3"></div>
                                </Col>
                                <Col xl={8} lg={9} md={10} sm={14} onClick={() => { tapOnce(this.areatoraise) }}>
                                    <div className="qualification2"></div>
                                </Col>
                                <Col xl={8} lg={9} md={10} sm={14} onClick={() => { tapOnce(this.getQueryProgressList) }}>
                                    <div className="qualification1"></div>
                                </Col>
                            </Row> */}
                            <Row className="home-service-section" gutter={[24, 24]} style={{ marginTop: '40px' }} align="stretch">
                                <Col xs={24} lg={12}>
                                    <Row className="home-entry-cards" gutter={[16, 16]}>
                                        <Col xs={24} sm={12}>
                                            <div
                                                className="home-entry-card"
                                                onClick={() => tapOnce(this.openReserveFromHome, null)}
                                            >
                                                <div className="home-entry-card__icon">
                                                    <img src={require("../../assets/images/preregistration.png").default} alt="" />
                                                </div>
                                                <div className="home-entry-card__content">
                                                    <div className="home-entry-card__title">预约登记</div>
                                                    <div className="home-entry-card__desc">如有意向房源可提交预约登记</div>
                                                </div>
                                                <div className="home-entry-card__line" />
                                            </div>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <div
                                                className="home-entry-card"
                                                onClick={() => tapOnce(this.openTenantDirectModal, null)}
                                            >
                                                <div className="home-entry-card__icon">
                                                    <img src={tenantDirectIcon} alt="" />
                                                </div>
                                                <div className="home-entry-card__content">
                                                    <div className="home-entry-card__title">租情直通车</div>
                                                    <div className="home-entry-card__desc">欢迎大家提出宝贵意见</div>
                                                </div>
                                                <div className="home-entry-card__line" />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={24} lg={12}>
                                    <Row className="home-work-guide-grid" gutter={[16, 16]}>
                                        {workGuideList.map((v) => (
                                            <Col xs={24} sm={12} key={v.url}>
                                                <div
                                                    className={`work-guide ${v.url}`}
                                                    onClick={() => this.fastWorkGuide(v)}
                                                >
                                                    <div>
                                                        <img src={v.icon} alt="" width={58} height={58} />
                                                    </div>
                                                    <div className="desc">
                                                        <div className="title">{v.title}</div>
                                                        <div className="fast">{v.desc}</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>
                            </Row>
                            {/* <Col xs={24} md={24} lg={24} xl={24} xxl={24} >
                                    <div className="home-title">
                                        <div className="left">
                                            <span className="images images-policy"></span>
                                            <div style={{ fontWeight: 'bold' }}>政策法规</div>
                                            <span>&nbsp;</span>
                                        </div>
                                        <div className="right" onClick={() => this.props.history.push({ pathname: '/policy' })}>查看全部</div>
                                    </div>
                                    <div>
                                        {
                                            policyList.map(v => {
                                                return (
                                                    <div key={v.id} className='policy' onClick={() => this.policyDetail(v)}>
                                                        <div className='time'>{v.publicTime.substr(0, 10)}</div>
                                                        <div style={{ marginLeft: 20, paddingRight: 20, borderBottom: '1px solid #F1F6FA' }}>
                                                            <div className='title'>{v.title}</div>
                                                            <div className='content'>{this.htmlStr2text(v.content)}</div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        <div>
                                            <Button type="primary" ghost style={{ marginLeft: 20 }} onClick={() => this.props.history.push({ pathname: '/policy' })}>查看更多</Button>
                                        </div>
                                    </div>
                                </Col> */}
                            <Row className="publicList" justify="space-around" align="middle" style={{ marginTop: '40px' }}>
                                <Col xs={24} md={24} lg={12} xl={12} xxl={12}>
                                    <div className="home-title">
                                        <div className="left">
                                            <span className="images images0"></span>
                                            <div style={{ fontWeight: 'bold' }}>最新资格证公示名单</div>
                                            <span>公示期不少于5个工作日</span>
                                        </div>
                                        <div className="right" onClick={() => tapOnce(this.getQualificationList, null)}>查看全部</div>
                                    </div>
                                    <div
                                        ref='newDiv'
                                        className='rolling-body'
                                        onMouseEnter={this.handleIndustryNewsEnter.bind(this)}
                                        onMouseLeave={this.handleIndustryNewsLeave.bind(this)}>
                                        <ul ref='newDivUI' className="rolling" >
                                            {publicList && publicList.length > 0 ?
                                                publicList.map(this.tableBody)
                                                : null
                                            }
                                        </ul>
                                    </div>
                                </Col>
                                <Col xs={0} md={0} lg={0} xl={0} xxl={1} ></Col>
                                <Col xs={24} md={24} lg={12} xl={12} xxl={11} >
                                    <div className="home-title">
                                        <div className="left">
                                            <span className="images images0"></span>
                                            <div style={{ fontWeight: 'bold' }}>项目供应情况展示</div>
                                            <span>&nbsp;</span>
                                        </div>
                                        <div className="right" onClick={() => tapOnce(this.getQualificationSupply, null)}>查看全部</div>
                                    </div>
                                    <div
                                        ref='newOther'
                                        className='rolling-body'
                                        onMouseEnter={this.handleIndustryOtherEnter.bind(this)}
                                        onMouseLeave={this.handleIndustryOtherLeave.bind(this)}
                                    >
                                        <ul
                                            ref='newOtherUI'
                                            className="rolling">
                                            {supplyList && supplyList.length > 0 ?
                                                supplyList.map((item, index) => {
                                                    return (
                                                        <li key={index} className='li' >
                                                            <span className="username">
                                                                {item.projectName}
                                                            </span>
                                                            <span className="rolling_content">
                                                                <span>
                                                                    {item.houseTypeName}
                                                                </span>
                                                                <span>
                                                                    {item.kezuCount}套可租
                                                                </span>
                                                                <span>
                                                                    {item.queueCount}人排队
                                                                </span>
                                                            </span>
                                                        </li>
                                                    );
                                                })
                                                : <Spin style={{ width: '100%', height: '600px', lineHeight: '600px' }} />
                                            }
                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="publicList" justify="space-around" align="middle" style={{ marginTop: '48px' }}>
                                <Col span={24} >
                                    <div className="home-title">
                                        <div className="left">
                                            <span className="images images1"></span>
                                            <div style={{ fontWeight: 'bold' }}>精选项目</div>
                                            <span>为您推荐精心挑选的小区</span>
                                        </div>
                                        <div className="right" onClick={() => { this.getProject() }}>查看更多</div>
                                    </div>
                                </Col>
                                <Col span={24} >
                                    <ul className='home-project'>
                                        {projectList && projectList.length > 0 ?
                                            projectList.map((item, index) => {
                                                return (
                                                    <li key={index} onClick={() => { this.getProjectDetail(item.projectName, item.projectNo) }}>
                                                        {/* <img src={item.mediaUrl[0]} style={{width:'200px',height:'133.3px'}} /> */}
                                                        <div className='project-images'>
                                                            <div style={{ backgroundImage: 'url(' + item.thumbnail[0] + ')', width: '100%', height: '100%', backgroundSize: '100%', borderRadius: '5px', backgroundRepeat: 'no-repeat' }}></div>
                                                        </div>
                                                        {/* <div style={{ backgroundImage: 'url(' + item.mediaUrl[0] + ')', width: '200px', height: '133.3px', backgroundSize: '100%' }}></div> */}
                                                        <div className="right" style={{ width: '250px' }}>
                                                            <div className="top" >
                                                                <span style={{ fontSize: '24px', color: '#262626', }}>{item.projectName}</span>

                                                                <div>{item.minRent}<span> 元/月 起</span></div>
                                                            </div>
                                                            <div className="bottom">
                                                                <div>
                                                                    <CheckOutlined /> 可租<Tooltip placement="topLeft" title={item.roomTypeCount}><span style={{ color: '#3651a9' }}>{item.kezuCount || 0}</span></Tooltip>套
                                                                </div>
                                                                <div className="shihu"><HomeOutlined /> {item.roomType && item.roomType.length > 0 ? item.roomType.split(',').map((item1, index1) => {
                                                                    return (
                                                                        <span key={index1}>{item1}室户{index1 + 1 == item.roomType.split(',').length ? '' : '/'}</span>
                                                                    );
                                                                }) : <span className='noData'>暂无数据</span>}</div>
                                                                <div><EnvironmentOutlined /> {item.location}</div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })
                                            : projectList.length == 0 ? <span className='noData'>暂无数据</span> : <Spin style={{ width: '100%', height: '600px', lineHeight: '600px' }} />
                                        }
                                    </ul>
                                </Col>
                            </Row>
                            <QualificationPublic ref="qualificationPublic" />
                            <QualificationSupply ref="qualificationSupply" />
                            <QueryProgress ref="queryProgress" />
                        </div>
                        <div className="col-lg-2"></div>
                    </Row>
                    <Modal title="预约登记" visible={reserveModalVisible} onOk={() => tapOnce(this.homeReserveHandleOk, null)} onCancel={this.homeReserveHandleCancel} destroyOnClose>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ marginBottom: 6 }}><span style={{ color: '#ff4d4f' }}>*</span>项目</div>
                            <Select
                                showSearch
                                optionFilterProp="children"
                                placeholder="请选择项目"
                                value={reserveSelectedProjectNo}
                                style={{ width: '100%' }}
                                onChange={this.onReserveProjectChange}
                                allowClear
                                disabled={reserveDetailLoading}
                                filterOption={(input, option) =>
                                    String(option.children || '').toLowerCase().indexOf((input || '').toLowerCase()) >= 0
                                }
                            >
                                {reserveWebsiteProjects.map((p) => p.openQueue == '1' && (
                                    <Option key={p.projectNo} value={p.projectNo}>{p.projectName}</Option>
                                ))}
                            </Select>
                            {reserveDetailLoading ? (
                                <div style={{ marginTop: 8 }}><Spin size="small" /> 正在加载项目户型信息</div>
                            ) : null}
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ marginBottom: 6 }}><span style={{ color: '#ff4d4f' }}>*</span>申请类型</div>
                            <Select placeholder="请选择申请类型" value={reserveApplyType || undefined} style={{ width: '100%' }} onChange={this.onReserveApplyTypeChange} allowClear>
                                <Option value="单身人士" disabled={isApplyTypeOptionDisabledForMarry('单身人士', reserveMarry)}>单身人士</Option>
                                <Option value="三人及以下家庭" disabled={isApplyTypeOptionDisabledForMarry('三人及以下家庭', reserveMarry)}>三人及以下家庭</Option>
                                <Option value="两孩家庭" disabled={isApplyTypeOptionDisabledForMarry('两孩家庭', reserveMarry)}>两孩家庭</Option>
                                <Option value="三孩家庭" disabled={isApplyTypeOptionDisabledForMarry('三孩家庭', reserveMarry)}>三孩家庭</Option>
                            </Select>
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ marginBottom: 6 }}><span style={{ color: '#ff4d4f' }}>*</span>婚姻状况</div>
                            <Select placeholder="请选择婚姻状况" value={reserveMarry || undefined} style={{ width: '100%' }} onChange={this.onReserveMarryChange} allowClear>
                                {MARRY_STATUS_OPTIONS.map((status) => (
                                    <Option
                                        key={status}
                                        value={status}
                                        disabled={isMarryOptionDisabledForApplyType(status, reserveApplyType)}
                                    >
                                        {status}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        {reserveProjectDetail && !reserveDetailLoading ? (
                            <div style={{ marginBottom: 12 }}>
                                <div style={{ marginBottom: 6 }}><span style={{ color: '#ff4d4f' }}>*</span>户型</div>
                                <Select placeholder="请选择户型" value={reservePaiduiHouseType || undefined} style={{ width: '100%' }} onChange={this.reserveHomeHouseTypeChange} allowClear disabled={!reserveApplyType}>
                                    {reserveApplyType === '单身人士' && reserveProjectDetail.roomTypeInfos && reserveProjectDetail.roomTypeInfos.length > 0 && reserveProjectDetail.roomTypeInfos.indexOf('一') !== -1 ? <Option value="一">一室户</Option> : null}
                                    {reserveApplyType === '单身人士' && reserveProjectDetail.roomTypeInfos && reserveProjectDetail.roomTypeInfos.length > 0 && reserveProjectDetail.roomTypeInfos.indexOf('二') !== -1 ? <Option value="二">二室户</Option> : null}
                                    {reserveApplyType && reserveApplyType !== '单身人士' && reserveProjectDetail.roomTypeInfos && reserveProjectDetail.roomTypeInfos.length > 0
                                        ? reserveProjectDetail.roomTypeInfos.split(',').map((pan, index) => (<Option value={pan} key={index}>{pan}室户</Option>))
                                        : null}
                                </Select>
                            </div>
                        ) : null}
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ marginBottom: 6 }}><span style={{ color: '#ff4d4f' }}>*</span>工作单位名称</div>
                            <Input placeholder="请输入工作单位名称" value={reserveWorkUnitName} onChange={(e) => this.setState({ reserveWorkUnitName: e.target.value })} />
                        </div>
                        <div>
                            <p>申请本项目，需要同时满足以下两项基本准入条件:</p>
                            <p>（一）上海市合法就业、在职工作;</p>
                            <p>（二）申请家庭宝山区范围内人均住房建筑面积低于15平方米。</p>
                        </div>
                    </Modal>

                    <Modal width={999} title={<h4 style={{ fontFamily: '宋体', marginBottom: '0', fontWeight: 'bold' }}>通知栏</h4>} visible={Views} closable={false} okButtonProps={{ disabled: secondsToGo == 0 ? false : true }} okText={okText} cancelText={false} maskClosable={false} onOk={() => this.handleOkAndhandleCancel()}>
                        <p style={{ fontSize: '16px', fontFamily: '宋体', fontWeight: 'bold' }}>尊敬的用户:<br /></p>
                        <p style={{ fontSize: '16px', fontFamily: '宋体', fontWeight: 'bold' }}>&nbsp;&nbsp;为了给您提供更好的安全服务，我们已将系统升级，您登录系统时，如原密码强度不够（密码长度至少8位，至少1个大写字母，1个小写字母，1个数字和1个特殊字符），请选择忘记密码自行修改。</p>
                        <p style={{ fontSize: '16px', fontFamily: '宋体', fontWeight: 'bold' }}>&nbsp;&nbsp;给您带来的不便，敬请谅解。感谢您一直以来的支持！</p>
                        <p style={{ fontSize: '16px', fontFamily: '宋体', fontWeight: 'bold' }}>&nbsp;&nbsp;服务平台已于近期更新上线新版本，版本试运行期间，如有疑问，请致电<span style={{ color: 'red' }}>56671727</span>或<span style={{ color: 'red' }}>56100661</span></p>
                        <p style={{ fontSize: '16px', fontFamily: '宋体', fontWeight: 'bold', textAlign: 'right' }}>{PAGE_NAME} <br /> {moment().format('LL')}</p>
                    </Modal>

                    <SelfTest ref={ref => this.selfTestRef = ref} />
                </Layout>
                <Footer />
            </Layout>
        )
    }
    ViewShow = () => {
        let { secondsToGo } = this.state
        this.timer = setInterval(() => {
            secondsToGo -= 1;
            this.setState({
                secondsToGo: secondsToGo,
                okText: secondsToGo + '秒'
            })
            if (secondsToGo == 0) {
                clearInterval(this.timer);
                this.setState({
                    okText: '确定'
                })
            }
        }, 1000);
        this.setState({
            Views: true
        }, () => {
            setTimeout(() => {
                if (secondsToGo == 0) clearInterval(this.timer);
            }, 1000);
        })
    }
    handleOkAndhandleCancel = () => {
        this.setState({
            Views: false
        }, () => {
            clearInterval(this.timer);
            sessionStorage.setItem('addInform', '1')
        })
    }
    handleOkAndhandleCancels = () => {
        this.setState({
            Views: false
        }, () => {
            clearInterval(this.timer);
        })
    }
    tableBody = (item, index) => {
        return (
            <li key={index}>
                <span className="username">
                    {item.username}
                </span>
                <span className="telephone">
                    {item.transactionNo}
                </span>
            </li>
        );
    }
    getQualificationList = () => {
        this.refs.qualificationPublic.showQualification()
    }
    getQualificationSupply = () => {
        this.refs.qualificationSupply.showQualification()
    }
    getQueryProgressList = () => {
        this.refs.queryProgress.showQueryProgress()
    }
    openTenantDirectModal = () => {
        message.error('功能暂未开放，相关服务流程完善后将上线，敬请期待。')
        return
        this.setState({
            tenantDirectVisible: true,
        })
    }
    closeTenantDirectModal = () => {
        this.setState({
            tenantDirectVisible: false,
        })
    }
    openLoginFromTenantDirect = () => {
        this.closeTenantDirectModal()
        this.openLoginHandler?.()
    }
    goToMyTenantDirect = () => {
        this.closeTenantDirectModal()
        this.props.history.push({ pathname: '/personal', query: { tab: '6' } })
    }
    registerOpenLogin = (handler) => {
        this.openLoginHandler = handler
    }
}
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home))
